import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import ReCaptcha from './Recaptcha';
const loadReCaptcha = (siteKey, callback = () => undefined) => {
    const script = document.createElement('script');
    if (!window.onLoadCaptchaV3Callback && callback) {
        window.onLoadCaptchaV3Callback = callback;
    }
    script.src = `https://www.recaptcha.net/recaptcha/api.js?onload=onLoadCaptchaV3Callback&render=${siteKey}`;
    document.body.appendChild(script);
};
export const useRecaptcha = (recaptchaSiteKey) => {
    const [recaptchaEnabled, setRecaptchaEnabled] = useState(false);
    const [token, setToken] = useState('');
    let recaptchaLoadedOnce = false;
    let repetitions = 0;
    useEffect(() => {
        if (recaptchaEnabled && !recaptchaLoadedOnce) {
            loadReCaptcha(recaptchaSiteKey);
            const interval = setInterval(() => {
                refresh();
                if (++repetitions === 5) {
                    clearInterval(interval);
                }
            }, 110000);
            setRecaptchaLoadedOnce();
            return () => {
                clearInterval(interval);
            };
        }
    }, [recaptchaEnabled]);
    const enableRecaptcha = () => {
        !recaptchaEnabled && setRecaptchaEnabled(true);
    };
    const refresh = () => {
        const recaptchaWindow = window;
        if (recaptchaWindow.grecaptcha && recaptchaWindow.grecaptcha.execute) {
            recaptchaWindow.grecaptcha
                .execute(recaptchaSiteKey)
                .then(function (refreshToken) {
                setToken(refreshToken);
            })
                .catch(() => {
                console.error('Failed to refresh recaptcha token');
            });
        }
    };
    const setRecaptchaLoadedOnce = () => {
        recaptchaLoadedOnce = true;
    };
    const verifyCallback = useCallback((recaptchaToken) => {
        setToken(recaptchaToken);
    }, []);
    const recaptchaComponent = recaptchaEnabled ? (_jsx(ReCaptcha, { action: 'submit', sitekey: recaptchaSiteKey, verifyCallback: verifyCallback })) : null;
    return [enableRecaptcha, recaptchaComponent, token, refresh];
};
